import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import "../privacyPolicy/PrivacyPolicy.css";

const ChildProtectionPolicy = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const filters = document.querySelector(".filters-row");

    const handleScroll = () => {
      if (!filters) return;

      const offset = filters.getBoundingClientRect().top;

      if (offset <= 80) {
        filters.classList.add("stuck");
      } else {
        filters.classList.remove("stuck");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Scroll to top smoothly when the component mounts / route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth" if you prefer a gentle scroll
    });
  }, []);

  const handleSectionClick = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <Header
        isMenuOpen={isMenuOpen}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      {/* ===== HERO ===== */}
      <section className="legal-hero">
        <div className="legal-container">
          <h1>TUTORSLINKS Child Protection & Safeguarding Policy</h1>
        </div>
      </section>

      {/* ===== CONTENT ===== */}
      <section className="legal-content-section">
        <div className="legal-container legal-grid">
          {/* ===== MOBILE SIDEBAR TOGGLE ===== */}
          <button
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? "Close Sections" : "View Sections"}
          </button>
          {isSidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}

          {/* ===== SIDEBAR ===== */}
          <aside className={`legal-sidebar ${isSidebarOpen ? "open" : ""}`}>
            <a href="#purpose" onClick={handleSectionClick}>
              Purpose
            </a>
            <a href="#scope" onClick={handleSectionClick}>
              Scope
            </a>
            <a href="#commitment" onClick={handleSectionClick}>
              Our Commitment
            </a>
            <a href="#responsibilities" onClick={handleSectionClick}>
              Responsibilities
            </a>
            <a href="#online-safety" onClick={handleSectionClick}>
              Online Safety
            </a>
            <a href="#reporting" onClick={handleSectionClick}>
              Reporting a Concern
            </a>
            <a href="#disciplinary" onClick={handleSectionClick}>
              Disciplinary Action
            </a>
            <a href="#training" onClick={handleSectionClick}>
              Training & Awareness
            </a>
            <a href="#confidentiality" onClick={handleSectionClick}>
              Confidentiality
            </a>
            <a href="#contact" onClick={handleSectionClick}>
              Contact Us
            </a>
          </aside>

          {/* ===== MAIN CONTENT ===== */}
          <div className="legal-content">
            <p className="last-updated">Last Updated: 28 February 2026</p>
            <p>
              At <strong>TUTORSLINKS (Efiko Edutech Ltd.)</strong>, we believe
              every child has the right to learn in a{" "}
              <strong>safe, respectful, and supportive environment</strong> —
              online or in person.
            </p>
            {/* <br /> */}
            {/* <p> */}
            This policy outlines how we protect minors and promote safeguarding
            across all platform activities.
            {/* </p> */}
            {/* 1 */}
            <section id="purpose">
              <h2>1. Purpose</h2>
              <p>The purpose of this policy is to:</p>
              <ul>
                <li>
                  Ensure the safety and well-being of children using
                  TutorsLinks.
                </li>
                <li>
                  Set clear expectations for tutors, training centres, and
                  staff.
                </li>
                <li>
                  Prevent and respond effectively to any form of abuse, neglect,
                  or exploitation.
                </li>
              </ul>
            </section>
            {/* 2 */}
            <section id="scope">
              <h2>2. Scope</h2>
              <p>This policy applies to: </p>
              <ul>
                <li>
                  All tutors, students, training centres, and employees
                  registered on TutorsLinks.
                </li>
                <li>
                  All learning sessions, communications, and activities
                  conducted through or arranged via the platform.{" "}
                </li>
                <li>
                  Both <strong>online</strong> and <strong>physical</strong>{" "}
                  classes facilitated by TutorsLinks users.
                </li>
              </ul>
            </section>
            {/* 3 */}
            <section id="commitment">
              <h2>3. Our Commitment</h2>
              <p>TutorsLinks commits to: </p>
              <ul>
                <li>
                  Providing a safe and positive learning environment for
                  children.{" "}
                </li>
                <li>
                  {" "}
                  Ensuring tutors and centres working with minors are properly{" "}
                  <strong>verified</strong> and <strong>vetted. </strong>
                </li>
                <li>
                  Responding swiftly and appropriately to any safeguarding
                  concerns.
                </li>
                <li>
                  Complying with all relevant Nigerian child protection laws and
                  international best practices.
                </li>
              </ul>
            </section>
            {/* 4 */}
            <section id="responsibilities">
              <h2>4. Responsibilities</h2>

              <h3>a. Tutors and Training Centres</h3>
              <p>All tutors and centres must:</p>
              <ul>
                <li>
                  Act in a professional and responsible manner when working with
                  children.
                </li>
                <li>
                  Never engage in any form of physical, emotional, or sexual
                  abuse, neglect, or exploitation.
                </li>
                <li>
                  Avoid inappropriate communication or relationships with minors
                  outside learning sessions.
                </li>
                <li>
                  Report any concerns or suspicious behavior immediately to
                  TutorsLinks support.{" "}
                </li>
                <li>
                  Maintain appropriate boundaries — no private, unmonitored
                  contact outside the platform.
                </li>
                <li>
                  Deliver lessons in safe, well-lit, and appropriate
                  environments (for physical classes).
                </li>
              </ul>

              <h3>b. Parents and Guardians</h3>
              <ul>
                <li>
                  Must consent to their child’s registration and
                  participation.{" "}
                </li>
                <li>
                  Should supervise or be aware of all online and in-person
                  sessions.
                </li>
                <li>
                  Are encouraged to review tutor profiles and report any
                  concerns to support.{" "}
                </li>
              </ul>

              <h3>c. TUTORSLINKS Management</h3>
              <p>TutorsLinks will:</p>
              <ul>
                <li>
                  Conduct ID verification and background checks where possible
                  for tutors teaching minors.
                </li>
                <li>Monitor communications on the platform for compliance.</li>
                <li>
                  Provide tools for reporting abuse or suspicious conduct.{" "}
                </li>
                <li>
                  Suspend or terminate accounts of any tutor or centre found
                  violating this policy.{" "}
                </li>
                <li>
                  Collaborate with relevant authorities for serious safeguarding
                  concerns.
                </li>
              </ul>
            </section>
            {/* 5 */}
            <section id="online-safety">
              <h2>5. Online Safety</h2>
              <p>For online lessons: </p>
              <ul>
                <li>
                  Video sessions should take place on secure and approved
                  platforms.{" "}
                </li>
                <li>
                  Tutors and students must dress appropriately and maintain
                  professionalism.
                </li>
                <li>
                  No recording, screen shotting, or sharing of lessons without
                  consent.
                </li>
                <li>
                  Personal contact information should not be exchanged outside
                  the TUTORSLINKS system.
                </li>
              </ul>
            </section>
            {/* 6 */}
            <section id="reporting">
              <h2>6. Reporting a Concern</h2>
              <p>If you believe a child is at risk of harm:</p>
              <ol>
                <li>
                  Report immediately to <strong>support@tutorslinks.com</strong>{" "}
                  or via the in-app “Report” button.
                </li>
                <li>
                  Provide clear details (student name, tutor name, date, and
                  description).
                </li>
                <li>
                  TutorsLinks will investigate and, if necessary, escalate to
                  child protection authorities.
                </li>
              </ol>
              <p>
                Reports are treated confidentially, and whistle-blowers are
                protected from retaliation.
              </p>
            </section>
            {/* 7 */}
            <section id="disciplinary">
              <h2>7. Disciplinary Action</h2>
              <p>
                Any tutor, centre, or staff member found violating this policy
                will face:{" "}
              </p>
              <ul>
                <li>Immediate suspension or termination of account.</li>
                <li>
                  Reporting to law enforcement or child protection agencies.
                </li>
                <li>Possible legal action under Nigerian law.</li>
              </ul>
            </section>
            {/* 8 */}
            <section id="training">
              <h2>8. Training and Awareness</h2>
              <p>TutorsLinks will: </p>
              <ul>
                <li>
                  Provide child safeguarding awareness materials to tutors and
                  centres.{" "}
                </li>
                <li>
                  {" "}
                  Include child protection guidelines during tutor onboarding
                  and training.{" "}
                </li>
                <li>Periodically review and update this policy.</li>
              </ul>
            </section>
            {/* 9 */}
            <section id="confidentiality">
              <h2>9. Confidentiality</h2>
              <p>
                All safeguarding matters are handled sensitively and in line
                with privacy laws. Personal information is shared only with
                authorized personnel or authorities when necessary.
              </p>
            </section>
            {/* 10 */}
            <section id="contact">
              <h2>10. Contact Us</h2>
              <p>
                For child protection or safeguarding concerns:
                <br />
                <strong>support@tutorslinks.com</strong>
                <br />
                <strong>TUTORSLINKS (Efiko Edutech Ltd.)</strong>
              </p>
            </section>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-container">
          <div className="shield-icon">
            <img src="/images/shield-icon.png" alt="Trust" />
          </div>
          <h2>Your Trust Is Our Priority</h2>
          <p>
            Our Tutors are committed to the highest standard of student learning,
            safety, privacy and data protection. Verified tutors and training centres display a verification badge.
          </p>
          <a href="" className="trust-btn">
            Get Started →
          </a>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default ChildProtectionPolicy;
